"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = flattenObject;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function flattenObject(obj) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".";
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  return Object.keys(obj).reduce(function (acc, k) {
    var pre = prefix.length ? prefix + separator : "";

    if ((0, _typeof2["default"])(obj[k]) === "object" && obj[k] !== null) {
      Object.assign(acc, flattenObject(obj[k], separator, pre + k));
    } else {
      acc[pre + k] = obj[k];
    }

    return acc;
  }, {});
}